import React, { useEffect, useMemo, useRef, useState } from "react";
import Head from "../../../../layout/head/Head";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import * as app_consts from "../../../../constants/react_app_consts";
import Content from "../../../../layout/content/Content";
import TablePageHeading from "../../components/page_heading/TablePageHeading";
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from "../../../../components/Component";
import TableList from "../../components/table/TableList";
import { employee_dashboard_actions_helper } from "../../../../actions/actions_helper";
import {
  fail_product_list,
  loading_product_list,
  reset_product_list,
  success_product_list,
} from "../../../../reducers/dashboard_reducers/products/product_list_Slice";
import {
  AMEND_PRODUCT_STATUS_ACCESS_DENIED_MSG,
  AMEND_PRODUCT_STATUS_ERR_MSG,
  AMEND_PRODUCT_STATUS_SUCCESS_MSG,
  RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG,
  RETRIEVE_PRODUCTS_LIST_ERR_MSG,
  RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
} from "../../../../constants/success_error_messages_consts";
import { useSelector } from "react-redux";
import { AMEND_PRODUCTS_STATUS, RETRIEVE_PRODUCTS_LIST } from "../../../../api/api_data";
import { messageToast } from "../../../../utils/Utils";
import ModalDetails from "../../components/modal/modal_details/ModalDetails";
import ModalConfirmCancel from "../../components/modal/modal_confirm_cancel/ModalConfirmCancel";
import {
  fail_amend_product_status,
  loading_amend_product_status,
  reset_amend_product_status,
  success_amend_product_status,
} from "../../../../reducers/dashboard_reducers/products/amend_product_status_Slice";
import ModalAdd from "../../components/modal/modal_add/ModalAdd";
import { findModuleAction, formatToSentenceCase } from "../../../../utils/functionalUtils";
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, Spinner, UncontrolledDropdown } from "reactstrap";
import { BiErrorCircle } from "react-icons/bi";
import { Link } from "react-router-dom";
import AuthError from "../../../components/page_messaging/AuthError";
import AuthLoader from "../../../components/page_messaging/AuthLoader";
import AuthNoData from "../../../components/page_messaging/AuthNoData";
import usePersistentState from "../../../../Hooks/usePersistentState";

const initial_actions_data = { add_product: false, amend_product_status: false };
const type = app_consts.PRODUCT_LIST;
const initial_amend_user_status = { product_id: "", account_status_id: "" };

const ProductList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page_data, setPageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [componentData, setComponentData] = useState(initial_actions_data);
  const [openModalDetails, setOpendModalDetails] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [detail, setDetail] = useState([]);
  const [acc_status, setAccStatus] = useState("");
  const [openConfirmCancelModal, setOpenConfirmCancelModal] = useState(false);
  const [amendStatusFormData, setAmendStatusFormData] = useState(initial_amend_user_status);
  const [errAmendAccStat, setErrAmendAccStat] = useState("");
  const [openAddModal, setOpenAddModal] = useState(false);
  const [account_actions, setAccountActions] = useState([]);
  const [error, setError] = useState("");
  const [sm, updateSm] = useState(false);
  const [searchTerm, setSearchTerm] = usePersistentState("product_list:searchTerm", "");
  const [selectedFilter, setSelectedFilter] = usePersistentState("product_list:selectedFilter", "All");
  const [currentPage, setCurrentPage] = usePersistentState("product_list:currentPage", 1);
  const [itemPerPage] = useState(10);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const skipInitialPageResetRef = useRef(true);

  //Retrieve Product List on Page Load
  useEffect(() => {
    retrieve_product_list();
    if (localStorage.getItem("log_cred"))
    {
      setAccountActions(JSON.parse(localStorage.getItem('log_cred'))?.user_actions);
    }
  }, []);

  // Listen to Changes In Account Actions
  useEffect(() => {
    if (account_actions)
    {
      let actions_data = initial_actions_data;
      account_actions?.map((module) => {
        if (module.module_name === app_consts.SYSTEM_MANAGEMENT) 
        {
          // Actions Data
          if (findModuleAction(app_consts.ADD_PRODUCT, module))
          {
            actions_data.add_product = true;
          }
          if (findModuleAction(app_consts.AMEND_PRODUCT_STATUS, module))
          {
            actions_data.amend_product_status = true;
          }
        }
      });
      setComponentData(actions_data);
    }
  }, [account_actions]);


  // Retrieve Product List
  const retrieve_product_list = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_product_list,
        success_product_list,
        fail_product_list,
        RETRIEVE_PRODUCTS_LIST_ERR_MSG,
        RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_PRODUCTS_LIST,
        null,
        RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG
      )
    );
  };

  //Listen to State of Product List
  const product_list = useSelector((state) => state.product_list.product_list);

  useEffect(() => {
    if (product_list.status !== app_consts.IDLE)
    {
      if (product_list.status === app_consts.LOADING)
      {
        setLoading(true);
      } else
      {
        setLoading(false);
        if (product_list.status === app_consts.FAIL)
        {
          messageToast(product_list.message, app_consts.FAIL);
          setError(product_list.message);
        } else if (product_list.status === app_consts.SUCCESS)
        {
          setPageData(product_list.data);
        }
        dispatch(reset_product_list());
      }
    }
  }, [product_list]);

  // RefreshList Function
  const refreshList = () => {
    setError("");
    retrieve_product_list();
    setLoading(true);
    setPageData([]);
  };

  // UseEffect for Specific Data
  useEffect(() => {
    if (selectedData)
    {
      setDetail(filterSpecificProduct(selectedData));
    }
  }, [selectedData]);

  // Filter Specific Product
  const filterSpecificProduct = (selectedData) => {
    const filtereredProduct = page_data?.filter((data) => data.product_id === selectedData);
    return filtereredProduct[0];
  };

  // Function to Amend Product Status
  const amend_Account_Status_modal = (product_id, account_status_id, account_status) => {
    setAccStatus(account_status);
    setOpenConfirmCancelModal(true);
    setSelectedData(product_id);
    setAmendStatusFormData({
      ...amendStatusFormData,
      ["product_id"]: product_id,
      ["account_status_id"]: account_status_id,
    });
  };

  // Function to Amend Branch Location Account Status
  const amend_Account_Status = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_amend_product_status,
        success_amend_product_status,
        fail_amend_product_status,
        AMEND_PRODUCT_STATUS_ERR_MSG,
        AMEND_PRODUCT_STATUS_SUCCESS_MSG,
        app_consts.POST,
        AMEND_PRODUCTS_STATUS,
        amendStatusFormData,
        AMEND_PRODUCT_STATUS_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Amend Product Status Reducer
  const amend_product_status = useSelector((state) => state.amend_product_status.amend_product_status);
  // UseEffect for Amend Product Status
  useEffect(() => {
    if (amend_product_status.status !== app_consts.IDLE)
    {
      if (amend_product_status.status !== app_consts.LOADING)
      {
        if (amend_product_status.status === app_consts.FAIL)
        {
          setErrAmendAccStat(amend_product_status.message);
        } else if (amend_product_status.status === app_consts.SUCCESS)
        {
          messageToast(
            `${detail && `${detail.product_name}'s `} Status has been Successfully Amended.`,
            app_consts.SUCCESS
          );
          setAccStatus("");
          setDetail([]);
          refreshList();
          setSelectedData("");
          setErrAmendAccStat("");
          setOpenConfirmCancelModal(false);
        }
        dispatch(reset_amend_product_status());
      }
    }
  }, [amend_product_status]);

  // Open Modal to Add to LIst
  const openAddList = () => {
    setOpenAddModal(true);
  };

  // Success Function for Adding Product Via Modal
  const successAddFunc = () => {
    setOpenAddModal(false);
    refreshList();
  };

  const current_page_data = useMemo(() => {
    let filteredData = page_data;

    // Step 2: Apply search if searchTerm exists
    if (searchTerm)
    {
      const lowerSearch = searchTerm.toLowerCase();
      filteredData = filteredData?.filter((item) => {
        return (
          item?.product_type
            ?.toLowerCase()
            .includes(lowerSearch) ||
          item?.product_name
            ?.toLowerCase()
            .includes(lowerSearch) ||
          item?.account_status
            ?.toLowerCase()
            .includes(lowerSearch)
        );
      });
    }

    return filteredData || [];
  }, [searchTerm, selectedFilter, page_data]);

  useEffect(() => {
    if (skipInitialPageResetRef.current) {
      skipInitialPageResetRef.current = false;
      return;
    }
    setCurrentPage(1);
  }, [searchTerm, selectedFilter, setCurrentPage]);

  useEffect(() => {
    const maxPage = Math.max(1, Math.ceil(current_page_data.length / itemPerPage));
    if (currentPage > maxPage) {
      setCurrentPage(maxPage);
    }
  }, [currentPage, current_page_data.length, itemPerPage, setCurrentPage]);

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <Head title="Product List" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Product List</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && ` Products: ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      refreshList();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            {
              !(loading || error) && (
                <>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#more"
                        className="btn btn-icon btn-trigger toggle-expand me-n1"
                        onClick={(ev) => {
                          ev.preventDefault();
                          updateSm(!sm);
                        }}
                      >
                        <Icon name="more-v"></Icon>
                      </a>
                      <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                        <ul className="nk-block-tools g-3">
                          {
                            findModuleAction(app_consts.ADD_PRODUCT, componentData) !== null && (
                              <>
                                {!loading && !error && (
                                  <li>
                                    <Button color="light" outline className="btn-white">
                                      <Icon name="download-cloud"></Icon>
                                      <span>Export to CSV</span>
                                    </Button>
                                  </li>
                                )}
                                <li className="nk-block-tools-opt">
                                  <Button
                                    className="toggle btn-icon d-md-none"
                                    color="primary"
                                    onClick={() => {
                                      openAddList();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                  </Button>
                                  <Button
                                    className="toggle d-none d-md-inline-flex"
                                    color="primary"
                                    onClick={() => {
                                      openAddList();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                    <span>Add Product</span>
                                  </Button>
                                </li>
                              </>
                            )
                          }
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </>
              )
            }
          </BlockBetween>
          {
            loading ?
              <>
                <AuthLoader loading_message="Loading Products..." />
              </>
              :
              error && error.length > 0 ?
                <>
                  <AuthError error_message={error} />
                </>
                :
                <>
                  {
                    page_data && page_data?.length > 0 ?
                      <>
                        <ul className="nk-block-tools g-3 d-flex justify-end">
                          <li>
                            <div className="">
                              <div className="form-icon form-icon-right">
                                <Icon name="search"></Icon>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                id="default-04"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                placeholder="Search for Product"
                              />
                            </div>
                          </li>
                        </ul>
                        <div className="nk-tb-list is-separate is-medium mt-1 mb-3">
                          <div className="card-inner p-0">
                            <DataTableBody>
                              <DataTableHead>
                                <DataTableRow size="sm">
                                  <span>Product Name</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span>Product Type</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span>UoM</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span>Product Status</span>
                                </DataTableRow>
                                <DataTableRow size="md" className="text-end">
                                  <span>Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {/*  */}
                              {currentItems?.length > 0
                                ? currentItems.map((item) => {
                                  return (
                                    <DataTableItem key={item?.product_id}>
                                      <DataTableRow size="sm">
                                        <Link to={`/dashboard/admin/products/${item?.product_id}`}>
                                          <span className="tb-product">
                                            <span className="title">{item?.product_name || "--"}</span>
                                          </span>
                                        </Link>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span className="tb-sub">{item?.product_type ? formatToSentenceCase(item?.product_type) : "--"}</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span className="tb-sub">{
                                          item?.pum_list ?
                                            item?.pum_list?.length == 1 ? item?.pum_list[0]?.unit_measurement_abbrev :
                                              item?.pum_list?.length > 1 ? `${item?.pum_list[0]?.unit_measurement_abbrev}, ${item?.pum_list[1]?.unit_measurement_abbrev}`
                                                : ""
                                            :
                                            ""
                                        }</span>
                                      </DataTableRow>
                                      <DataTableRow size="md">
                                        <span className="tb-odr-status">
                                          <Badge
                                            color={item?.account_status === formatToSentenceCase(app_consts.ACTIVE_LOWER) ? "success" : "warning"}
                                            className="badge-dot"
                                          >
                                            {item?.account_status?.toUpperCase() || "--"}
                                          </Badge>
                                        </span>
                                      </DataTableRow>
                                      <DataTableRow className="nk-tb-col-tools">
                                        <ul className="nk-tb-actions gx-1">
                                          <li>
                                            <UncontrolledDropdown>
                                              <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                                <Icon name="more-h"></Icon>
                                              </DropdownToggle>
                                              <DropdownMenu end>
                                                <ul className="link-list-opt no-bdr">
                                                  <li>
                                                    <DropdownItem
                                                      tag="a"
                                                      href="#edit"
                                                      onClick={(ev) => {
                                                        ev.preventDefault();
                                                        // setOpendModalDetails(true);
                                                        // setSelectedData(item.product_id);
                                                      }}
                                                    >
                                                      <Link to={`/dashboard/admin/products/${item?.product_id}`}>
                                                        <Icon name="eye-fill"></Icon>
                                                        <span>View Details</span>
                                                      </Link>
                                                    </DropdownItem>
                                                  </li>
                                                  {componentData?.amend_product_status && (
                                                    <>
                                                      <li className="divider"></li>
                                                      {item.account_status_id !== 1 && (
                                                        <>
                                                          <li>
                                                            <DropdownItem
                                                              tag="a"
                                                              href="#edit"
                                                              onClick={(ev) => {
                                                                ev.preventDefault();
                                                                amend_Account_Status_modal(item.product_id, app_consts.ACTIVATE_ACCOUNT_ID, app_consts.ACTIVATE_ACCOUNT);
                                                              }}
                                                            >
                                                              <Icon color="" name="check-round-fill"></Icon>
                                                              <span>Activate Product</span>
                                                            </DropdownItem>
                                                          </li>
                                                        </>
                                                      )}
                                                      {item.account_status_id !== 2 && (
                                                        <>
                                                          <li>
                                                            <DropdownItem
                                                              tag="a"
                                                              href="#edit"
                                                              onClick={(ev) => {
                                                                ev.preventDefault();
                                                                amend_Account_Status_modal(item.product_id, app_consts.SUSPEND_ACCOUNT_ID, app_consts.SUSPEND_ACCOUNT);
                                                              }}
                                                            >
                                                              <Icon name="pause-circle"></Icon>
                                                              <span>Suspend Product</span>
                                                            </DropdownItem>
                                                          </li>
                                                        </>
                                                      )}
                                                      {item.account_status_id !== 3 && (
                                                        <>
                                                          <li>
                                                            <DropdownItem
                                                              tag="a"
                                                              href="#edit"
                                                              onClick={(ev) => {
                                                                ev.preventDefault();
                                                                amend_Account_Status_modal(item.product_id, app_consts.DEACTIVATE_ACCOUNT_ID, app_consts.DEACTIVATE_ACCOUNT);
                                                              }}
                                                            >
                                                              <Icon name="cross-c"></Icon>
                                                              <span>Deactivate Product</span>
                                                            </DropdownItem>
                                                          </li>
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </ul>
                                              </DropdownMenu>
                                            </UncontrolledDropdown>
                                          </li>

                                        </ul>
                                      </DataTableRow>
                                    </DataTableItem>
                                  );
                                })
                                : null}
                            </DataTableBody>
                            {currentItems?.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Add Modal */}
                        <ModalAdd
                          openModal={openAddModal}
                          setOpenModal={setOpenAddModal}
                          modalTitle="Add Product"
                          modalDescription="Please Complete this form to Add a Product"
                          type={type}
                          size="lg"
                          succFunc={successAddFunc}
                        />
                        {/* Yes or No Modal */}
                        <ModalConfirmCancel
                          openModal={openConfirmCancelModal}
                          setOpenModal={setOpenConfirmCancelModal}
                          modalTitle={`${acc_status} ${detail && `${detail.product_name}`}?`}
                          modalDescription={`Are you sure that you want to ${acc_status} ${detail.product_name}?`}
                          buttonConfirm="Confirm"
                          buttonCancel="Cancel"
                          succFunc={amend_Account_Status}
                          errAmend={errAmendAccStat}
                          setErrAmend={setErrAmendAccStat}
                        />
                      </>
                      :
                      <>
                        <AuthNoData no_data_message={"No Products Found."} />
                      </>
                  }

                </>
          }
        </BlockHead>
      </Content >
    </>
  );
};

export default ProductList;
